<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="时间范围：">
            <el-select v-model="formInline.dateType" placeholder="请选择" style="width: 150px; margin-right: 8px;">
                <el-option label="充电开始时间" :value="1"></el-option>
                <el-option label="充电结束时间" :value="2"></el-option>
            </el-select>
            <el-date-picker
                v-model="formInline.dateRange"
                type="datetimerange"
                value-format="YYYY-MM-DD HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="截止时间"
                style="width: 360px;"
            />
        </el-form-item>
        <el-form-item label="场站大类（可多选）：">
            <el-select v-model="formInline.stationTypes" multiple clearable placeholder="请选择" style="width: 180px;" collapse-tags collapse-tags-tooltip>
                <el-option label="高速" :value="1"></el-option>
                <el-option label="市区" :value="2"></el-option>
                <el-option label="内部" :value="3"></el-option>
                <!-- <el-option label="社区" :value="4"></el-option> -->
            </el-select>
        </el-form-item>
        <el-form-item label="场站（可多选）：">
            <el-select v-model="formInline.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="充电桩类型：">
            <el-select v-model="formInline.pileTypes" placeholder="请选择" style="width: 150px;">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="交流桩" :value="1"></el-option>
                <el-option label="直流桩" :value="2"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="用户类型（可多选）：">
            <el-select v-model="formInline.userTypes" multiple clearable placeholder="请选择" style="width: 180px;" collapse-tags collapse-tags-tooltip>
                <el-option label="个人预付费" :value="0"></el-option>
                <el-option label="企业预付费" :value="1"></el-option>
                <el-option label="企业后付费" :value="2"></el-option>
                <el-option label="个人后付费" :value="4"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="primary" @click="refresh">刷新</el-button>
            <el-button type="primary" @click="exportData">导出</el-button>
        </el-form-item>
    </el-form>

    <div class="summary-box" v-if="summaryData">
        <el-row :gutter="16">
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">累计充电量</div>
                    <div class="summary-value">{{ summaryData.chargeQuantity || 0 }} <span class="unit">kWh</span></div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">实收金额</div>
                    <div class="summary-value">{{ summaryData.receivedAmount || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">实收充电电费</div>
                    <div class="summary-value">{{ summaryData.electricityFee || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">实收充电服务费</div>
                    <div class="summary-value">{{ summaryData.serviceFee || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">累计充电次数</div>
                    <div class="summary-value">{{ summaryData.chargeCount || 0 }} <span class="unit">次</span></div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">钱包余额消费</div>
                    <div class="summary-value">{{ summaryData.walletAmount || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="3">
                <div class="summary-item">
                    <div class="summary-label">微信支付分消费</div>
                    <div class="summary-value">{{ summaryData.wechatPayScoreAmount || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
        </el-row>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="场站" min-width="150" show-overflow-tooltip>
            <template #default="scope">
                <span :style="{ fontWeight: scope.row.summaryRow ? 'bold' : 'normal' }">{{ scope.row.stationName || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="场站大类" min-width="100">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '-' : stationTypeFilter(scope.row.stationType) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="累计充电量" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.chargeQuantity || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="累计充电时长" min-width="120">
            <template #default="scope">
                <span>{{ formatDuration(scope.row.durationMinute) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实收金额" min-width="100">
            <template #default="scope">
                <span>{{ scope.row.receivedAmount || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实收充电电费" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.electricityFee || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实收充电服务费" min-width="130">
            <template #default="scope">
                <span>{{ scope.row.serviceFee || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="毛利润" min-width="100">
            <template #default="scope">
                <span>{{ scope.row.grossProfit || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="净利润" min-width="100">
            <template #default="scope">
                <span>{{ scope.row.netProfit || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电枪数" min-width="100">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '' : (scope.row.gunCount || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="累计充电次数" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.chargeCount || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均消费金额" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '-' : (scope.row.averageAmount || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均充电量" min-width="110">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '-' : (scope.row.averageChargeQuantity || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均充电功率" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '-' : (scope.row.averagePower || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均充电时长" min-width="130">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '-' : formatDuration(scope.row.averageDurationMinute) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="时间利用率" min-width="110">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '-' : (scope.row.timeUtilization || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="钱包余额消费" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.walletAmount || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="支付分消费" min-width="110">
            <template #default="scope">
                <span>{{ scope.row.wechatPayScoreAmount || 0 }}</span>
            </template>
        </el-table-column>
    </el-table>

    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
    name: 'StationData',
    data() {
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const endTimeWithBuffer = new Date(now.getTime() - 5 * 60 * 1000); // Subtract 5 minutes buffer for server time difference
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        return {
            stationOptions: [],
            formInline: {
                stationTypes: [],
                stationIds: [],
                userTypes: [],
                pileTypes: null,
                dateType: 2,
                dateRange: [formatDate(todayStart), formatDate(endTimeWithBuffer)],
            },
            tableData: [],
            summaryData: null,
            currentPage: 1,
            pageSize: 20,
            total: 0,
        }
    },
    mounted() {
        this.getStationOptions();
        this.getList();
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.getStationOptions();
                }
            },
            immediate: true
        },
        'formInline.stationTypes': {
            handler(newVal, oldVal) {
                // 如果选中项减少，清除对应类型的场站
                if (oldVal && oldVal.length > 0 && newVal && newVal.length < oldVal.length) {
                    const removedTypes = oldVal.filter(type => !newVal.includes(type));
                    const allStations = this.$store.state.stationList || [];
                    // 找出被移除类型对应的场站ID
                    const removedStationIds = allStations
                        .filter(station => removedTypes.includes(Number(station.type)))
                        .map(station => station.id);
                    // 从已选场站中清除这些ID
                    this.formInline.stationIds = this.formInline.stationIds.filter(id => !removedStationIds.includes(id));
                }
                this.getStationOptions();
            }
        }
    },
    methods: {
        formatDuration(minutes) {
            if (!minutes || minutes === 0) return '0分钟';
            const mins = Math.round(minutes);
            const hours = Math.floor(mins / 60);
            const remainingMins = mins % 60;
            if (hours > 0) {
                return `${hours}时${remainingMins}分`;
            }
            return `${remainingMins}分钟`;
        },
        getStationOptions() {
            const allStations = this.$store.state.stationList || [];
            console.log(allStations,'allStations---');
            if (this.formInline.stationTypes && this.formInline.stationTypes.length > 0) {
                this.stationOptions = allStations.filter(station =>
                    this.formInline.stationTypes.includes(Number(station.type))
                    && Number(station.state) !== 1
                );
            } else {
                this.stationOptions = [];
            }
        },
        search() {
            this.currentPage = 1;
            this.getList();
        },
        refresh() {
            const now = new Date();
            const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };
            this.formInline = {
                stationTypes: [],
                stationIds: [],
                userTypes: [],
                pileTypes: null,
                dateType: 2,
                dateRange: [formatDate(todayStart), formatDate(now)],
            };
            this.currentPage = 1;
            this.getList();
        },
        exportData() {
            let that = this;
            let param = {
                dateType: that.formInline.dateType,
            };
            if (that.formInline.stationTypes.length > 0) {
                param.stationTypes = that.formInline.stationTypes;
            }
            param.stationIds = that.formInline.stationIds;
            if (that.formInline.userTypes.length > 0) {
                param.userTypes = that.formInline.userTypes;
            }
            if (that.formInline.pileTypes !== null) {
                param.pileTypes = [that.formInline.pileTypes];
            }
            if (that.formInline.dateRange && that.formInline.dateRange.length === 2) {
                param.startTime = that.formInline.dateRange[0];
                param.endTime = that.formInline.dateRange[1];
            }
            that.$axios.post("bi-server/report/station-summary/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
                if (result instanceof Blob) {
                    if (result.type && result.type.includes('application/json')) {
                        const reader = new FileReader();
                        reader.onload = () => {
                            try {
                                const errorMsg = JSON.parse(reader.result);
                                ElMessage.error(errorMsg.message || errorMsg.msg || '导出失败');
                            } catch (e) {
                                ElMessage.error('导出失败');
                            }
                        };
                        reader.readAsText(result);
                    } else {
                        ElMessage.success('导出成功');
                    }
                } else if (result.code !== 200) {
                    ElMessage.error(result.message || '导出失败');
                }
            }).catch(error => {
                if (error.response && error.response.data) {
                    const blob = error.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorMsg = JSON.parse(reader.result);
                            ElMessage.error(errorMsg.message || errorMsg.msg || '导出失败');
                        } catch (e) {
                            ElMessage.error('导出失败');
                        }
                    };
                    reader.readAsText(blob);
                } else {
                    ElMessage.error('导出失败');
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        getList() {
            let that = this;
            let param = {
                page: that.currentPage,
                pageSize: that.pageSize,
                dateType: that.formInline.dateType,
            };
            if (that.formInline.stationTypes.length > 0) {
                param.stationTypes = that.formInline.stationTypes;
            }
            if (that.formInline.stationIds.length > 0) {
                param.stationIds = that.formInline.stationIds;
            }
            if (that.formInline.userTypes.length > 0) {
                param.userTypes = that.formInline.userTypes;
            }
            if (that.formInline.pileTypes !== null) {
                param.pileTypes = [that.formInline.pileTypes];
            }
            if (that.formInline.dateRange && that.formInline.dateRange.length === 2) {
                param.startTime = that.formInline.dateRange[0];
                param.endTime = that.formInline.dateRange[1];
            }
            that.$axios.post("bi-server/report/station-summary/page", JSON.stringify(param)).then(result => {
                if (result.code === 200 && result.data) {
                    that.summaryData = result.data.summary || null;
                    if (result.data.page) {
                        that.tableData = result.data.page.records || [];
                        that.total = result.data.page.total || 0;
                    }
                }
            });
        },
        stationTypeFilter(type) {
            const typeMap = {
                1: '高速',
                2: '市区',
                3: '内部',
                4: '其他',
            };
            return typeMap[type] || '-';
        },
    }
}
</script>

<style lang="scss" scoped>
/* 搜索表单无 search_nav 包裹（模板根节点）；全局标签 96px 放不下"场站大类（可多选）："，放宽到 154px；
   用 .demo-form-inline.el-form 提高优先级，否则会被后注入的 global-search.css 同优先级规则压回 */
.demo-form-inline.el-form :deep(.el-form-item__label) {
    width: 154px;
    min-width: 154px;
}
.summary-box {
    background-color: #f5f7fa;
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 6px;
}
.summary-item {
    background: #ffffff;
    padding: 12px 10px;
    border-radius: 6px;
    text-align: center;
    transition: all 0.3s ease;
    border: 1px solid #e4e7ed;
    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }
}
.summary-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}
.summary-value {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    .unit {
        font-size: 12px;
        font-weight: normal;
        color: #909399;
    }
}
</style>